// GOV-7 Phase 2 — singleton loader for the Google Maps JavaScript API (PRESENTATION / RENDERER ONLY).
//
// - The browser key comes from the build env REACT_APP_GOOGLE_MAPS_BROWSER_KEY. It is a referrer-restricted
//   (app-staging.servisfy.com/*), Maps-JavaScript-API-only key. It is NEVER logged, never rendered as text —
//   it only ever appears in the loader script's src query string (identical trust model to the Firebase
//   browser key already shipped in the bundle).
// - Loads ONLY the base Maps JS from https://maps.googleapis.com (already CSP-whitelisted; no CSP change).
//   No routing libraries are requested — routing/ETA stay server-side.
// - If window.google.maps already exists (or under test), resolves immediately without injecting a script.

let _promise = null;

export function googleMapsKey() {
  return process.env.REACT_APP_GOOGLE_MAPS_BROWSER_KEY || '';
}

export function loadGoogleMaps() {
  if (typeof window !== 'undefined' && window.google && window.google.maps) {
    return Promise.resolve(window.google.maps);
  }
  if (_promise) return _promise;

  const key = googleMapsKey();
  if (!key) return Promise.reject(new Error('maps_key_absent'));

  _promise = new Promise((resolve, reject) => {
    try {
      const done = () =>
        window.google && window.google.maps ? resolve(window.google.maps) : reject(new Error('maps_load_failed'));
      const existing = document.getElementById('gmaps-js');
      if (existing) {
        existing.addEventListener('load', done);
        existing.addEventListener('error', () => reject(new Error('maps_load_failed')));
        return;
      }
      const s = document.createElement('script');
      s.id = 'gmaps-js';
      s.async = true;
      s.defer = true;
      // key lives ONLY in the query string (never logged); pinned weekly channel; no extra libraries.
      s.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(key)}&v=weekly`;
      s.onload = done;
      s.onerror = () => reject(new Error('maps_load_failed'));
      document.head.appendChild(s);
    } catch (e) {
      reject(new Error('maps_load_failed'));
    }
  });
  return _promise;
}

// test-only: reset the module singleton between cases
export function __resetGoogleMapsLoaderForTests() {
  _promise = null;
}
